import { motion } from "framer-motion";
import { Send } from "lucide-react";
import { TELEGRAM_URL } from "../i18n";
import { trackCTA } from "../lib/track";

export const StickyCTA = ({ t, hidden }) => (
  <motion.a
    data-testid="sticky-mobile-cta"
    href={TELEGRAM_URL}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => trackCTA("sticky_mobile")}
    initial={{ y: 96, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.5, delay: 1, ease: "easeOut" }}
    className={`fixed inset-x-4 bottom-4 z-40 flex items-center justify-center gap-2.5 rounded-full bg-[#EAB308] py-4 text-base font-bold text-[#0B0E11] shadow-[0_8px_40px_rgba(234,179,8,0.45)] active:scale-95 transition-transform duration-150 sm:hidden ${hidden ? "hidden" : ""}`}
  >
    <Send className="h-5 w-5" />
    {t.nav.joinCommunity}
  </motion.a>
);
